/* globals confirm, console, module, require, window */
/* jshint esversion:6, globalstrict:true */
'use strict';

const jQuery = require('jquery'),
    Marionette = require('backbone.marionette'),
    _ = require('lodash'),
    //
    Images = require('../collections/images'),
    ImagesCarousel = require('./imagesCarousel'),
    ImagesEditor = require('./imagesEditor'),
    templates = require('../utilities/handlebars').templates,
    EOL = null;

module.exports = Marionette.View.extend({
    attributes: {
        id: 'pictures',
        name: 'images',
        class: 'images section'
    },
    childViewEvents: {
        //
        'edit:end': function (options) {this.trigger('edit:end', options);},
        'edit:inProgress': function (options) {this.trigger('edit:inProgress', options);},
        'edit:start': function (options) {this.trigger('edit:start', options);}
    },
    events: {
        'click button': 'onClickButton'
    },
    regions: {
        imagesCarousel: {el: 'div[name=imagesCarousel]', replaceElement: true},
        imagesEditor:   {el: 'div[name=imagesEditor]',   replaceElement: true}
    },
    tagName: 'div',
    template: templates.imagesSection,
    //
    initialize: function () {
        this.images = new Images([], {programId: this.options.programId});
        this.templateContext = {
            hasAdminAccess: this.options.hasAdminAccess
        };
    },
    onClickButton: function (event) {
        const mode = _.bind(function (mode) {
                jQuery('div[name=imagesCarousel], button[name=edit]', this.$el).toggleClass('hidden', mode === 'edit');
                jQuery('div[name=imagesEditor], button[name=save], button[name=cancel]', this.$el).toggleClass('hidden', mode === 'display');
            }, this);
        switch (event.currentTarget.dataset.action) {
            case 'cancel':
                mode('display');
                break;
            case 'edit':
                mode('edit');
                break;
            case 'save':
                mode('display');
                break;
        }
        return false;
    },
    onRender: function () {
        if (!this.options.hasAdminAccess) {
            this.showChildView('imagesCarousel', new ImagesCarousel({images: this.images}));
        } else {
            this.showChildView('imagesEditor',   new ImagesEditor({images: this.images, programId: this.options.programId}));
        }
        return this;
    }
});
